module.exports = __webpack_public_path__ + "img/mobile-second-bg1.584102cf.jpg";